var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:['vts-tooltip', _vm.classes.toggle],attrs:{"id":_vm.id,"tabindex":"0","aria-describedby":(_vm.id + "__content")},on:{"focus":function($event){_vm.show = true},"blur":function($event){_vm.show = false},"mouseenter":_vm.onMouseenter,"mouseleave":_vm.onMouseleave}},[_vm._t("default"),_vm._v(" "),_c('span',{class:[
      'vts-tooltip__content',
      {
        'vts-tooltip__content--visible': _vm.show,
      },
      _vm.classes.content ],attrs:{"id":(_vm.id + "__content"),"role":"tooltip","aria-hidden":!_vm.show + ''}},[_vm._t("tooltip")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }